import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Row, Typography } from 'components';

const { Text } = Typography;

interface IBrandsDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data?: Record<string, any>[];
}

export const BrandsDrawer: FC<IBrandsDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={() => onExpand()}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Brands'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={() => onExpand()} type="text" />
      </div>
      <Row>
        {data?.map((brand) => (
          <Col key={brand.id} span={24} className={'padding-8'}>
            <Link to={`${ADMIN_ROUTES.brand.view}/${brand.id}/management`} target={'_blank'}>
              <Text type={'secondary'} underline>
                {brand.name}
              </Text>
            </Link>
          </Col>
        ))}
      </Row>
    </Drawer>
  );
});
